import {
  CREATE_LAYER,
  UPDATE_LAYER,
  DELETE_LAYER,
  DELETE_LAYERS,
  REPLACE_LAYERS,
  CHANGE_SORT_ORDER,
  FETCH_EXISTING_SKETCH_SUCCESS,
  UPDATE_SKETCH,
  SAVE_SKETCH_SUCCESS,
  FETCH_LAYER_DATA,
  FETCH_LAYER_DATA_SUCCESS,
  FETCH_LAYER_DATA_FAILURE,
  UPDATE_ZOOM,
  UPDATE_MEASUREMENT_FONT_SIZE,
  UPDATE_CENTER,
  SET_SELECTED_LAYER_ID,
  SET_SELECTED_POPUP_LAYER_ID,
  SET_MODE,
  CREATE_TAPE_FEATURE,
  UPDATE_TAPE_FEATURE,
  DELETE_TAPE_FEATURE,
  REPLACE_TAPE_FEATURES,
  UNDO_TAPE_FEATURES,
  REDO_TAPE_FEATURES,
  PUSH_TAPE_FEATURES_HISTORY,
  SET_SELECTED_TAPE_FEATURE_ID,
  FETCH_EXISTING_TAPE_SKETCH_SUCCESS,
  SAVE_TAPE_SKETCH_SUCCESS,
  FETCH_TAPE_SKETCH_CONFIG_SUCCESS,
  SHIFT_TAPE_SKETCH_ORIGIN,
  SET_TAPE_SKETCH_BEARING,
} from './constants';

export const createLayer = layer => ({
  type: CREATE_LAYER,
  layer,
});

export const updateLayer = (layerId, key, val) => ({
  type: UPDATE_LAYER,
  layerId,
  key,
  val,
});
export const replaceLayers = layers => ({
  type: REPLACE_LAYERS,
  layers,
});

export const deleteLayer = layerId => ({
  type: DELETE_LAYER,
  layerId,
});
export const deleteLayers = layerIds => ({
  type: DELETE_LAYERS,
  layerIds,
});

export const changeSortOrder = layers => ({
  type: CHANGE_SORT_ORDER,
  layers,
});

export const updateSketch = data => ({
  type: UPDATE_SKETCH,
  sketchData: data,
});

export const saveSketch = layers => ({});

export const fetchExistingSketchSuccess = sketch => {
  const sketchJson = JSON.parse(sketch.sketchJson);
  return {
    type: FETCH_EXISTING_SKETCH_SUCCESS,
    sketch,
    layers: sketchJson.layers,
    center: sketchJson.center,
    geoJson: sketchJson.geoJson,
    zoomLevel: sketchJson.zoomLevel,
    measurementFontSize: sketchJson.measurementFontSize,
  };
};

export const saveSketchSuccess = sketch => ({
  type: SAVE_SKETCH_SUCCESS,
  sketch,
});

export const fetchLayerData = () => ({
  type: FETCH_LAYER_DATA,
});

export const fetchLayerDataSuccess = layerData => ({
  type: FETCH_LAYER_DATA_SUCCESS,
  layerData,
});

export const fetchLayerDataFailure = error => ({
  type: FETCH_LAYER_DATA_FAILURE,
  error,
});

export const updateZoom = zoomLevel => ({
  type: UPDATE_ZOOM,
  zoomLevel,
});
export const updateMeasurementFontSize = measurementFontSize => ({
  type: UPDATE_MEASUREMENT_FONT_SIZE,
  measurementFontSize,
});

export const updateCenter = center => ({
  type: UPDATE_CENTER,
  center,
});
export const setSelectedLayerId = layerId => ({
  type: SET_SELECTED_LAYER_ID,
  layerId,
});
export const setSelectedPopupLayerId = layerId => ({
  type: SET_SELECTED_POPUP_LAYER_ID,
  layerId,
});

export const setMode = mode => ({
  type: SET_MODE,
  mode,
});

export const createTapeFeature = feature => ({
  type: CREATE_TAPE_FEATURE,
  feature,
});

export const updateTapeFeature = (featureId, key, val) => ({
  type: UPDATE_TAPE_FEATURE,
  featureId,
  key,
  val,
});

export const deleteTapeFeature = featureId => ({
  type: DELETE_TAPE_FEATURE,
  featureId,
});

export const replaceTapeFeatures = tapeFeatures => ({
  type: REPLACE_TAPE_FEATURES,
  tapeFeatures,
});

export const undoTapeFeatures = () => ({
  type: UNDO_TAPE_FEATURES,
});

export const redoTapeFeatures = () => ({
  type: REDO_TAPE_FEATURES,
});

// Snapshots the current tapeFeatures onto the undo stack and clears the redo stack — dispatched
// explicitly right before a mutation that CREATE_TAPE_FEATURE/DELETE_TAPE_FEATURE/
// REPLACE_TAPE_FEATURES don't already cover on their own (those three push their own snapshot
// inside the reducer case, since each is a single discrete action). This one covers a whole
// vertex/edge/body drag (pushed once at drag-start, not once per pointermove frame) and a
// multi-field property patch (pushed once before all its updateTapeFeature dispatches), so Undo
// reverts the whole gesture/edit, not a single intermediate frame or field.
export const pushTapeFeaturesHistory = () => ({
  type: PUSH_TAPE_FEATURES_HISTORY,
});

export const setSelectedTapeFeatureId = featureId => ({
  type: SET_SELECTED_TAPE_FEATURE_ID,
  featureId,
});

export const fetchExistingTapeSketchSuccess = tapeSketch => ({
  type: FETCH_EXISTING_TAPE_SKETCH_SUCCESS,
  tapeSketch,
});

export const saveTapeSketchSuccess = tapeSketch => ({
  type: SAVE_TAPE_SKETCH_SUCCESS,
  tapeSketch,
});

export const fetchTapeSketchConfigSuccess = tapeConfig => ({
  type: FETCH_TAPE_SKETCH_CONFIG_SUCCESS,
  tapeConfig,
});

export const shiftTapeSketchOrigin = (deltaLat, deltaLng) => ({
  type: SHIFT_TAPE_SKETCH_ORIGIN,
  deltaLat,
  deltaLng,
});

export const setTapeSketchBearing = bearing => ({
  type: SET_TAPE_SKETCH_BEARING,
  bearing,
});
